import React from 'react';
import { Box, Typography, Paper, Avatar } from '@mui/material';
import { Security } from '@mui/icons-material';
import AdminLogsTable from '../../components/admin/logs/AdminLogsTable';

const Logs = () => {
    return (
        <Box sx={{ p: 3 }}>
            {/* Header */}
            <Paper elevation={4} sx={{
                mb: 4,
                p: 4,
                borderRadius: 3,
                background: 'linear-gradient(135deg, #f44336, #ef5350)',
                color: 'white'
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    <Avatar sx={{
                        background: 'rgba(255,255,255,0.2)',
                        backdropFilter: 'blur(10px)',
                        border: '3px solid rgba(255,255,255,0.3)',
                        width: 80,
                        height: 80
                    }}>
                        <Security sx={{ fontSize: 40 }} />
                    </Avatar>
                    <Box>
                        <Typography variant="h3" fontWeight={800} sx={{ mb: 1 }}>
                            Security & Activity Logs
                        </Typography>
                        <Typography variant="h6" sx={{ opacity: 0.9 }}>
                            Monitor system activity and security events
                        </Typography>
                        <Typography variant="body2" sx={{ opacity: 0.8, mt: 1 }}>
                            Track admin actions, user activities, and system changes
                        </Typography>
                    </Box>
                </Box>
            </Paper>

            {/* Admin Logs Table */}
            <AdminLogsTable />
        </Box>
    );
};

export default Logs;
